import {
    message,
    Spin,
    Row,
    Col,
    Select,
    Space,
    Checkbox,
    Popconfirm,
    PageHeader,
} from "antd";
import React, { Component } from "react";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    round6Decimals,
    dineroDisabledMask,
    ModalItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    DisponibilidadInsumoModal,
    HistorialInsumoClienteModal,
    DetalleInsumoModal,
} from "../../../../Components/Items";
import VentasForm from "../../../../Components/VentasForm";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MandarCorreoCotizacion from "../MandarCorreoCotizacion/MandarCorreoCotizacion";
import ElegirPreCotizacion from "../../PreCotizacionIngenieria/ElegirPreCotizacion/ElegirPreCotizacion";
import { SendOutlined, FileExcelOutlined } from "@ant-design/icons";
import { descargarExcelDocumento } from "../../../../Components/DescargarDocumentosMasivo";
import GenerarVenta from "../GenerarVenta/GenerarVenta";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import TrazabilidadSteps from "../../Ventas/TrazabilidadSteps/TrazabilidadSteps";
import { FilaInsumoCotizacion } from "../../../../Components/FilaInsumosCotizacion";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

class VerCotizacion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        descargandoExcel: false,
        objetoClientes: null,
        todasClientes: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoPrecios: null,
        todasPrecios: null,
        objetoInsumos: null,
        todasInsumos: [],
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        objetoBancos: null,
        todasBancos: null,
        objetoUsuarios: null,
        todasUsuarios: null,
        objetoMonedas: null,
        todasMonedas: null,
        objetoCanalesVenta: null,
        todasCanalesVenta: null,
        impuestos: [],
        modalConfirmacion: false,
        modalCorreo: false,
        modalCorreoId: null,
        modalElegirPreCotizacionVisible: false,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteNombre: null,
        modalElegirTipoDeClienteId: null,
        valuesForm: null,
        entregarInsumos: false,
        total: 0,
        subtotal: 0,
        arrayImpuestos: [],
        arrayRetenciones: [],
        totalPagar: 0,
        venderSinInventario: false,
        id: this.props.location.state.id,
        modalGenerarVenta: false,
        numeroCotizacion: "",
        direccionesCliente: [],
        objetoDireccionesCliente: null,
        todasPaises: [],
        todasEstado: [],
        todasMunicipios: [],
        todasColonias: [],
        objetoPaises: null,
        objetoEstados: null,
        objetoMunicipios: null,
        objetoColonias: null,
        loadingEntrega: false,
        addendaMabe: false,
        loadingPlantasEntrega: false,
        anticipos: false,
        trace: null,
        leyenda: null,
        leyendaActiva: false,
        tieneInsumoDeCambio: false,
        mostrarImprimirImagen: false,
        paquetes : [],
        objetoDoctores: null,
        todasDoctores: null,
        objetoPacientes: null,
        todasPacientes: null,
        objetoCirugias: null,
        todasCirugias: null,
        showFormaDePagoCard: false,
        tiposDescuento: {},
        modalDisponibilidadVisible: false,
        insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
        modalHistorialClienteVisible: false,
        insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
        modalDetalleInsumoVisible: false,
        insumoSeleccionadoDetalle: { id: null, nombre: '' },
        totalCantidadInsumos: 0,
    };
    componentDidMount() {
        this.consultarTodo();
    }
    abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
        this.setState({ modalDisponibilidadVisible: true, insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId } });
    }

    cerrarDisponibilidad = () => {
        this.setState({ modalDisponibilidadVisible: false });
    }

    abrirDetalleInsumo = (insumoId, nombre) => {
        if (!insumoId) return;
        this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
    }

    cerrarDetalleInsumo = () => {
        this.setState({ modalDetalleInsumoVisible: false });
    }

    // Clic derecho en la misma celda donde el doble clic abre Disponibilidad. Pantalla de solo
    // lectura: no se pasa permitirUsarPrecio.
    abrirHistorialCliente = (insumoId, nombre, index) => {
        if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
        this.setState({
            modalHistorialClienteVisible: true,
            insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
        });
    }

    cerrarHistorialCliente = () => {
        this.setState({ modalHistorialClienteVisible: false });
    }

    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "cotizaciones/selectDatosParaCotizacion",
                { empresaId: this.props.empresaId, cotizacionId: this.state.id },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        mostrarImprimirImagen: res.data.imprimirImagenes,
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        todasCanalesVenta: res.data.canalesVenta || [],
                        objetoCanalesVenta: (res.data.canalesVenta || []).map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });

        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }

        await axios
            .post(
                "cotizaciones/datosCotizacion",
                { empresaId: this.props.empresaId, cotizacionId: this.state.id },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                if (res.data.status === 404) {
                    message.error("Error no se encontro informacion de la cotizacion");
                } else {
                    const insumosConImagenes = res.data.insumos.map((insumo) => {
                        const precioUnitarioConImpuestos =
                            insumo.precioUnitario + insumo.impuestos / insumo.cantidad;
                        const pendiente = insumo.cantidad - (insumo.vendido || 0);

                        return {
                            ...insumo,
                            precioUnitarioConImpuestos,
                            pendiente,
                            // Preservar los valores de imagen que vienen de la base de datos
                            imprimirImagen: insumo.imprimirImagen || false,
                            archivosPrincipal: insumo.archivosPrincipal || [],
                            modoImagen: insumo.modoImagen || null,
                            archivosCargados: insumo.archivosCargados || [],
                        };
                    });

                    const insumosAgregarTodos = res.data.insumosCatalogo || [];
                    
                    if (insumosAgregarTodos.length === 0 && res.data?.insumos?.length > 0) {
                        return message.error('No se pudieron obtener todos los insumos de la cotización');
                    }

                    this.setState({
                        todasInsumos: insumosAgregarTodos,
                    });
                    
                    this.setState({ todasInsumos: insumosAgregarTodos });

                    const tiposDescuentoIniciales = {};
                    insumosConImagenes.forEach((insumo, index) => {
                        if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                            tiposDescuentoIniciales[index] = 'cantidad';
                        } else {
                            tiposDescuentoIniciales[index] = 'porcentaje';
                        }
                    });

                    this.setState({ tiposDescuento: tiposDescuentoIniciales });

                    this.formRef.current.setFieldsValue({
                        ...res.data,
                        factura: res.data.factura ? 1 : 2,
                        fechaEntregaEstimada: res.data.fechaEntregaEstimada
                            ? moment(res.data.fechaEntregaEstimada)
                            : undefined,
                        fechaCotizacion: res.data.fechaCotizacion
                            ? moment(res.data.fechaCotizacion)
                            : moment(res.data.createdAt),
                        fechaVigencia: res.data.fechaVigencia
                            ? moment(res.data.fechaVigencia)
                            : undefined,
                        insumos: insumosConImagenes,
                    });

                    this.setState({
                        estado: res.data.estado,
                        factura: res.data.factura,
                        nombreCotizacion: 'Cotizacion: ' + res.data.numero,
                        remision: res.data.remision,
                        total: res.data.total,
                        subtotal: res.data.subtotal,
                        arrayImpuestos: res.data.arrayImpuestos,
                        totalPagar: res.data.totalPagar,
                        arrayRetenciones: res.data.arrayRetenciones,
                        numeroCotizacion: res.data.cotizacionSerie + ' ' + res.data.cotizacionNumero,
                        anticipos: res.data.anticipos || false,
                        trace: res.data.trace,
                        leyendaActiva: res.data.leyendaCliente ? true : false,
                        leyenda: res.data.leyendaCliente ? true : false,
                        tieneInsumoDeCambio : res.data.tieneInsumoDeCambio,
                        paquetes: res.data.paquetes || [],
                        totalCantidadInsumos: (res.data.insumos || []).reduce(
                            (suma, insumo) => suma + (Number(insumo.cantidad) || 0),
                            0
                        ),
                        preCotizacionIngenieriaId: res.data.preCotizacionIngenieriaId,
                    });
                    if (res?.data?.direccionEntrega?.plantaEntregaId) {
                        this.setState({ addendaMabe: true });
                    } else {
                        this.setState({ addendaMabe: false });
                    }

                    // Cargar direcciones del cliente para mostrar dirección fiscal
                    if (res.data.clienteId) {
                        try {
                            const responseCliente = await axios.post("clientes/buscarCliente", {
                                clienteId: res.data.clienteId,
                                empresaId: this.props.empresaId
                            }, { headers: this.props.headersToken });
                            if (responseCliente.data.success === 2) {
                                this.setState({
                                    direccionesCliente: responseCliente.data.cliente.direcciones || [],
                                });
                            }
                        } catch (err) {
                            console.error("Error al buscar cliente para dirección fiscal", err);
                        }
                    }

                }

            });
        // Cargar información de entrega si la cotización ya tiene dirección
        const direccionEntregaInicial = this.formRef.current?.getFieldValue("direccionEntrega");
        if (direccionEntregaInicial && (direccionEntregaInicial.estadoId || direccionEntregaInicial.calle)) {
            this.consultarInformacionEntrega();
        }
        this.setState({ loading: false });
    }
    atras() {
        this.props.history.goBack();
    }
    async onChangeInsumoProyecto(value, key, tipo) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
        );
        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        const precio = insumo.precios.find(
            (valuePrecios) => valuePrecios.precioId?.toString() === precioId
        );
        if (precio) {
            arrayValue[key].precioUnitario = precio.precio;
        } else {
            message.info("Este insumo no tiene ese precio");
            arrayValue[key].precioUnitario = 0;
        }

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = this.state.tiposDescuento[key] === 'cantidad'
                ? round6Decimals(arrayValue[key].descuentoCantidad || 0)
                : round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = this.state.tiposDescuento[key] === 'cantidad'
                ? round6Decimals(arrayValue[key].descuentoCantidad || 0)
                : round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );

                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
        this.setState({ addendaMabe: cliente?.addendaMabe || false });

    }
    onChangeContado(value) {
        this.setState({ showFormaDePagoCard: value !== 1 });
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        if (!clienteId) return;
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        this.formRef.current.setFieldsValue({
            precioId: value === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
        });
    }
    async descargarExcel() {
        this.setState({ descargandoExcel: true });
        await descargarExcelDocumento({
            modulo: "cotizacion",
            id: this.state.id,
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
        });
        this.setState({ descargandoExcel: false });
    }

    cerrarMandarCorreoCotizacion() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
    }
    enviarCotizacion(value) {
        this.setState({ modalCorreo: true, modalCorreoId: value });
    }

    generarVentaDeCotizacion() {
        this.setState({ modalGenerarVenta: true });
    }

    cerrarGenerarVentaDeContizacion() {
        this.setState({
            modalGenerarVenta: false,
        });
        this.consultarTodo();
    }

    cancelarCotizacion(value) {
        this.setState({ loading: true });
        axios
            .post(
                "cotizaciones/cancelarCotizacion",
                { cotizacionId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Cotizacion cancelada");
                    this.consultarTodo();
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
            });
    }

    async onChangeEstado(value, inicial) {
        if (!inicial) {
            this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    municipioId: undefined,
                    coloniaId: undefined
                }
            });
        }
        await axios
            .post(
                "municipios/selectMunicipios",
                { estadoId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoMunicipios = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasMunicipios: res.data,
                        objetoMunicipios: objetoMunicipios,
                    });
                }
            });
    }

    async onChangeMunicipio(value, inicial) {
        await axios
            .post(
                "colonias/selectColonias",
                { municipioId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoColonias = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.cp + " - " + value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasColonias: res.data,
                        objetoColonias: objetoColonias,
                    });
                }
            });
    }


    async onSearchColonia(value) {
        if (value.toString().length === 5) {
            await axios
                .post(
                    "colonias/buscarCP",
                    { cp: value },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                        message.info("No se encontro el codigo postal");
                    } else {
                        this.formRef.current.setFieldsValue({
                            direccionEntrega: {
                                paisId: res.data.paisId,
                                estadoId: res.data.estadoId,
                                municipioId: res.data.municipioId
                            }
                        });
                        this.onChangeEstado(res.data.estadoId, true);
                        this.onChangeMunicipio(res.data.municipioId, true);
                    }
                });
        }
    }
    async onSelectColoniaId(coloniaId, fieldKey) {
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
        if (!direccionEntrega?.colonia) {
            const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
            await this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    colonia: nombreColonia
                }
            })
        }
    }

    async handleChangeDireccionEntrega(value) {
        this.setState({ loadingEntrega: true })
        if (value) {
            const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
            if (direccion) {
                if (direccion.estadoId) {
                    await this.onChangeEstado(direccion.estadoId, true);
                }
                if (direccion.municipioId) {
                    await this.onChangeMunicipio(direccion.municipioId, true);
                }
                if (direccion?.plantaEntregaId) {
                    await this.onSearchPlantaEntrega(direccion?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
                }
                this.formRef.current.setFieldsValue({
                    direccionEntrega: {
                        paisId: direccion.paisId,
                        estadoId: direccion.estadoId,
                        municipioId: direccion.municipioId,
                        coloniaId: direccion.coloniaId,
                        colonia: direccion.colonia,
                        calle: direccion.calle,
                        numeroCalle: direccion.numeroCalle,
                        numeroInterior: direccion.numeroInterior,
                        descripcion: direccion.descripcion,
                        telefono: direccion.telefono,
                        correo: direccion.correo,
                        observaciones: direccion.observaciones,
                        plantaEntregaId: direccion?.plantaEntregaId,
                        referencia: direccion?.referencia,
                        clienteNombre: direccion?.clienteNombre,
                        clienteRfc: direccion?.clienteRfc
                    }
                })
            }
        }
        this.setState({ loadingEntrega: false })
    }

    consultarInformacionEntrega() {
        if (this.state.todasPaises.length > 0) return
        this.setState({ loadingEntrega: true })
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
        if (direccionEntrega?.plantaEntregaId && this.state.addendaMabe) {
            this.onSearchPlantaEntrega(direccionEntrega?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
        }
        axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
            headers: this.props.headersToken
        })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({

                        loadingEntrega: false,
                        todasPaises: res.data.paises,
                        todasEstado: res.data.estados,
                        todasMunicipios: res.data.municipios,
                        todasColonias: res.data.colonias,
                        objetoMunicipios: res.data.municipios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoColonias: res.data.colonias.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.cp + " - " + value.nombre}
                                </Option>
                            );
                        }),
                        objetoPaises: res.data.paises.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                        objetoEstados: res.data.estados.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                    })
                } else {
                    message.info("No se encontró información para entrega")
                    this.setState({
                        loadingEntrega: false
                    })
                }
            })
    }
    onSearchPlantaEntrega = async (value, fieldKey, opts = {}) => {
        const { byId = false, setSelected = false } = opts;
        if (byId) {
            await axios
                .post(
                    "plantaDeEntrega/selectPlantaEntregaPorId",
                    { id: value },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    const p = res?.data?.dato || null;
                    if (!p || !p._id) {
                        this.setState(prev => ({
                            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                        }));
                        message.warning("No se encontró la planta por ID.");
                        return;
                    }

                    const option = (
                        <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
                            {p.label}
                        </Option>
                    );

                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));

                    if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
                        const form = this.props.form || this.form;
                        form.setFields([
                            { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
                        ]);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    message.error("Error al buscar planta por ID");
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                });

            return;
        }
        this.setState(prev => ({
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
        }));
        await axios
            .post(
                "plantaDeEntrega/selectPlantasDeEntrega",
                {
                    query: value || ""
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res?.data.success !== 2) {
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                    return;
                }
                const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
                const options = items.map(it => (
                    <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
                        {it.label}
                    </Option>
                ));

                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            })
            .catch((err) => {
                console.error(err);
                message.error("Error al buscar plantas de entrega");
                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            });
    }
    generarAnticipo() {
        this.props.history.push("/panel/agregarVenta", { anticipo: true, cotizacionId: this.state.id });
    }

    getInsumosColumns() {
        const columns = [];

        columns.push({ title: "#", width: "3%" });

        if (this.state.mostrarDatosPaquete) {
            columns.push({ title: "Paquete", width: "3%" });
        }

        columns.push(
            { title: "Clave", width: "6%" },
            { title: "Insumo", width: this.state.mostrarDatosPaquete ? "21%" : "22%" },
            { title: "Unidad", width: "6%" },
            { title: "Proyecto", width: "12%" },
            { title: "PU", width: "9%" },
            { title: "Precio Neto", width: "9%" },
            {
                title: (
                    <>
                        <div>Cant.</div>
                        <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
                            Total: {this.state.totalCantidadInsumos}
                        </div>
                    </>
                ),
                width: "8%",
            },
            { title: "Desc.", width: "7%" },
            { title: "Subtotal / Impuesto / Total", width: "13%" },
        );

        return columns;
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove }) {
        const insumosValues = this.formRef.current?.getFieldValue('insumos') || [];

        const estadoFila = {
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            paquetes: this.state.paquetes,
            mostrarDatosPaquete: false,
            indicesSeleccionadosPaquete: [],
            paqueteEditadoId: null,
            todasInsumos: this.state.todasInsumos,
            mostrarImprimirImagen: this.state.mostrarImprimirImagen,
            objetoProyectos: this.state.objetoProyectos,
            permisos: {
                permisoModificarPrecioUnitario: false,
                permisoModificarDescuento: false,
            }
        };

        const funcionesVacias = {
            editarPaquete: () => {},
            toggleImprimirDesglose: () => {},
            desagruparPaquete: () => {},
            eliminarPaqueteCompleto: () => {},
            onChangeCantidadPaquete: () => {},
            onCheckInsumoPaquete: () => {},
            onChangeInsumoProyecto: () => {},
            onChangePrecioCantidadDescuento: () => {},
            abrirVerInsumo: () => {},
            seleccionarModoImagen: () => {},
            abrirModalImagen: () => {},
            abrirLeyenda: () => {},
            abrirElegirMarbetes: () => {},
            abrirElegirLotes: () => {},
            abrirElegirAgrupaciones: () => {},
            abrirObservaciones: () => {},
            abrirVistaPreviaInsumo: () => {},
            onDobleClickDescuento: () => {},
            onChangePrecioConImpuestos: () => {},
            abrirDisponibilidad: this.abrirDisponibilidad,
            abrirHistorialCliente: this.abrirHistorialCliente,
            abrirDetalleInsumo: this.abrirDetalleInsumo,
            remove: () => {}
        };

        return (
            <FilaInsumoCotizacion
                key={key}
                field={{ key, name, fieldKey, ...restField }}
                index={arrayKey}
                form={this.formRef.current}
                insumosValues={insumosValues}
                estado={estadoFila}
                funciones={funcionesVacias}
                modoLectura={true}
                tiposDescuento={this.state.tiposDescuento}
            />
        );
    }

    renderEntregaContent() {
        return (
            <TabEntregaDireccion
                readOnly={true}
                direccionEntrega={this.formRef.current?.getFieldValue("direccionEntrega")}
                clienteDireccion={this.state.direccionesCliente?.[0]}
                loadingEntrega={this.state.loadingEntrega}
                formInstance={this.formRef.current}
                objetoMunicipios={this.state.objetoMunicipios}
                objetoEstados={this.state.objetoEstados}
                objetoPaises={this.state.objetoPaises}
                objetoPlantasEntrega={this.state.objetoPlantasEntrega}
            />
        );
    }

    getObservacionesConfig() {
        return {
            observaciones: {
                value: this.formRef.current?.getFieldValue('observaciones') || '',
                onSave: (value) => {
                    this.formRef.current?.setFieldsValue({ observaciones: value });
                    this.forceUpdate();
                },
                disabled: true
            },
            observaciones2: {
                value: this.formRef.current?.getFieldValue('observaciones2') || '',
                onSave: (value) => {
                    this.formRef.current?.setFieldsValue({ observaciones2: value });
                    this.forceUpdate();
                },
                disabled: true
            },
            checkboxes: [
                ...(this.props.quitarImpuestosOpcionalVentas ? [{
                    name: 'quitarImpuestos',
                    label: 'Quitar Impuestos',
                    onChange: null,
                    disabled: true
                }] : []),
                {
                    name: 'imprimirObservaciones',
                    label: 'Imprimir Observaciones',
                    onChange: null,
                    disabled: true
                },
                {
                    name: 'deshabilitarBanco',
                    label: 'Deshabilitar Banco',
                    onChange: (e) => {
                        axios.post("cotizaciones/editarDeshabilitarBanco", {
                            cotizacionId: this.state.id,
                            empresaId: this.props.empresaId,
                            deshabilitarBanco: e.target.checked,
                        }).then((res) => {
                            if (res.data.success !== 2) {
                                message.info("La cotización no se edito");
                            }
                        });
                    }
                }
            ],
            totales: (
                <table className="table" style={{ marginTop: 0 }}>
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                                Total Insumos
                            </th>
                            <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                                {this.state.totalCantidadInsumos}
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ width: "50%" }}>
                                Subtotal
                            </th>
                            <td className="td-totales-right" style={{ width: "50%" }}>
                                {dineroDisabledMask(this.state.subtotal)}
                            </td>
                        </tr>
                    </tbody>
                    {this.state.arrayImpuestos.map((valueArray) => (
                        <tbody key={valueArray.descripcionFactura}>
                            <tr>
                                <th className="th-totales">
                                    {valueArray.descripcionFactura}
                                </th>
                                <td className="td-totales-right">
                                    {dineroDisabledMask(valueArray.totalImpuestos)}
                                </td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales">Total</th>
                            <td className="td-totales-right">
                                {dineroDisabledMask(this.state.total)}
                            </td>
                        </tr>
                    </tbody>
                    {this.state.arrayRetenciones.map((value) => (
                        <tbody key={value.descripcionFactura}>
                            <tr>
                                <th className="th-totales">
                                    {value.descripcionFactura}
                                </th>
                                <td className="td-totales-right">
                                    {dineroDisabledMask(value.totalRetenciones)}
                                </td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales">Total a Pagar</th>
                            <td className="td-totales-right">
                                {dineroDisabledMask(this.state.totalPagar)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            )
        };
    }

    render() {
        const isMobile = window.innerWidth <= 1000;

        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={`Ver Cotización ( ${this.state.numeroCotizacion} )`}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={(
                        <TrazabilidadSteps trace={this.state.trace} />
                    )}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin
                        spinning={this.state.loading}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                        <Form
                            ref={this.formRef}
                            name="VerCotizacion"
                            layout
                            onFinish={(values) =>
                                this.setState({ modalConfirmacion: true, valuesForm: values })
                            }
                            onFinishFailed={this.onFinishFailed}
                        >
                            <VentasForm

                                formInstance={this.formRef.current}
                                isMobile={isMobile}
                                datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                                monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}

                                // Contenido de Datos Generales
                                datosGeneralesContent={(
                                    <>
                                        <Row gutter={[16, 8]} align="top">
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Row>
                                                    <Col span={24}>
                                                        <FormItem
                                                            label="Cliente"
                                                            name="clienteId"
                                                            required
                                                            margin
                                                            labelCol={{ span: 6 }}
                                                            wrapperCol={{ span: 18 }}
                                                        >
                                                            <SelectClientesItem
                                                                empresaId={this.props.empresaId}
                                                                headersToken={this.props.headersToken}
                                                                disabled
                                                                dropdownMatchSelectWidth={600}
                                                                width="100%"
                                                                placeholder="Cliente"
                                                                onChange={(valueId, cliente) => this.onChangeCliente(valueId, cliente)}
                                                            />
                                                        </FormItem>
                                                    </Col>
                                                </Row>

                                                {this.state.leyenda && (
                                                    <Row align="middle" style={{ marginTop: 4 }}>
                                                        <Col span={24}>
                                                            <Row align="middle">
                                                                <Col span={4} style={{ textAlign: 'right', paddingRight: 8 }}>
                                                                    <FormItem
                                                                        name="leyenda"
                                                                        valuePropName="checked"
                                                                        initialValue={this.state.leyendaActiva ? true : false}
                                                                        noStyle
                                                                    >
                                                                        <Checkbox disabled>
                                                                            <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                                                                Leyenda:
                                                                            </span>
                                                                        </Checkbox>
                                                                    </FormItem>
                                                                </Col>
                                                                <Col span={20}>
                                                                    {this.state.leyendaActiva && (
                                                                        <FormItem
                                                                            name="leyendaCliente"
                                                                            noStyle
                                                                        >
                                                                            <InputItem placeholder="Escribe la leyenda aquí" disabled />
                                                                        </FormItem>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </Col>

                                            {/* Fecha */}
                                            <Col xs={12} sm={8} md={10} lg={10}>
                                                <FormItem
                                                    label="Fecha:"
                                                    name="fechaCotizacion"
                                                    required
                                                    margin
                                                    initialValue={moment()}
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Cotización"
                                                        allowClear={false}
                                                    />
                                                </FormItem>
                                            </Col>

                                           

                                            
                                        </Row>

                                        <Row gutter={[16, 8]}>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <FormItem
                                                    label="Vendedor"
                                                    name="vendedorId"
                                                    required
                                                    margin
                                                    initialValue={this.props.usuarioId}
                                                    labelCol={{ span: 6 }}
                                                    wrapperCol={{ span: 18 }}
                                                >
                                                    <SelectItem placeholder="Vendedor" disabled>
                                                        {this.state.objetoUsuarios}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>

                                            {/* Método */}
                                            <Col xs={12} sm={8} md={10} lg={10}>
                                                <FormItem
                                                    label="Método"
                                                    name="contado"
                                                    initialValue={1}
                                                    required
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 10 }}
                                                >
                                                    <SelectItem disabled onChange={this.onChangeContado.bind(this)}>
                                                        <Option value={1}>Contado - PUE</Option>
                                                        <Option value={2}>Crédito - PPD</Option>
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                           
                                        </Row>
                                    </>
                                )}

                                datosVentaContent={
                                    <>
                                        {/* Precio */}
                                            <Col xs={12} sm={8} md={24} lg={24}>
                                                <FormItem
                                                    name="precioId"
                                                    label="Precio"
                                                    required
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <SelectItem placeholder="Precio" disabled>
                                                        {this.state.objetoPrecios}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>

                                            {/* Proyecto */}
                                            <Col xs={12} sm={8} md={24} lg={24}>
                                                <FormItem
                                                    name="proyectoId"
                                                    label="Proyecto"
                                                    required
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <SelectItem placeholder="Proyecto" disabled>
                                                        {this.state.objetoProyectos}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>

                                            {/* Canal */}
                                            <Col xs={12} sm={8} md={24} lg={24}>
                                                <FormItem
                                                    name="canalDeVentaId"
                                                    label="Canal"
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <SelectItem placeholder="Canal de Venta" disabled>
                                                        {this.state.objetoCanalesVenta}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>

                                            {/* Fecha Vigencia */}
                                            <Col xs={12} sm={8} md={24} lg={24}>
                                                <FormItem
                                                    label="F. Vig"
                                                    name="fechaVigencia"
                                                    required
                                                    margin
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha Vigencia"
                                                        allowClear={false}
                                                    />
                                                </FormItem>
                                            </Col>

                                    </>
                                }


                                datosClienteContent={(
                                    <>
                                        <Row gutter={[16, 8]}>
                                            <Col span={24}>
                                                <FormItem
                                                    name="ordenDeCompra"
                                                    label="O Compra"
                                                    margin
                                                    pattern
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem placeholder="Orden de Compra" disabled />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    name="req"
                                                    label="Req"
                                                    margin
                                                    pattern
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem placeholder="Requisición" disabled />
                                                </FormItem>
                                            </Col>

                                            <Col span={24}>
                                                <FormItem
                                                    pattern
                                                    name='atencion'
                                                    label='Atención a'
                                                    margin
                                                    tooltip="Indica a quién dirigir este documento."
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 16 }}
                                                >
                                                    <InputItem disabled />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                extrasContent={(
                                    <Row gutter={[16, 8]}>
                                        <Col span={24}>
                                            <FormItem
                                                name="fechaEntregaEstimada"
                                                label="F. Entrega Est."
                                                margin
                                                labelCol={{ span: 8 }}
                                                wrapperCol={{ span: 16 }}
                                            >
                                                <DatePickerItem disabled placeholder="Fecha de entrega estimada" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                )}

                                // Contenido de Forma de Pago
                                formaDePagoContent={this.state.showFormaDePagoCard ? (
                                    <FormItem
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                            prev.contado !== curr.contado ||
                                            prev.factura !== curr.factura
                                        }
                                    >
                                        {({ getFieldValue }) => {
                                            const contado = getFieldValue("contado");
                                            const factura = getFieldValue("factura");

                                            const diasCredito =
                                                contado !== 1 ? (
                                                    <FormItem
                                                        label="Días de crédito"
                                                        name="diasCredito"
                                                        numberCero
                                                        margin
                                                        required
                                                        initialValue={0}
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <InputNumberItem disabled placeholder="Días de Crédito" />
                                                    </FormItem>
                                                ) : null;

                                            const usoCFDI =
                                                factura === 1 ? (
                                                    <FormItem
                                                        name="usoDeCfdiId"
                                                        label="Uso de CFDI"
                                                        margin
                                                        required
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <SelectItem disabled placeholder="Uso de CFDI">
                                                            {this.state.objetoUsosDeCFDI}
                                                        </SelectItem>
                                                    </FormItem>
                                                ) : null;

                                            if (!usoCFDI && !diasCredito) {
                                                return null;
                                            }

                                            return (
                                                <>
                                                    {usoCFDI}
                                                    {diasCredito}
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                  ) : null}

                                // Contenido Doctor
                                doctorContent={this.props.equipoMedico ? (
                                    <>
                                        <Row gutter={[8, 8]}>
                                            <Col xs={24} sm={12} md={24} lg={24} span={24}>
                                                <FormItem
                                                    name="doctorId"
                                                    label="Doctor:"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 14 }}
                                                    margin
                                                >
                                                    <SelectItem placeholder="Doctor" disabled>
                                                        {this.state.objetoDoctores}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} sm={12} md={24} lg={24} span={24}>
                                                <FormItem
                                                    name="pacienteId"
                                                    label="Paciente:"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 14 }}
                                                    margin
                                                >
                                                    <SelectItem placeholder="Paciente" disabled>
                                                        {this.state.objetoPacientes}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} span={24}>
                                                <FormItem
                                                    name="cirugiaId"
                                                    label="Cirugía:"
                                                    labelCol={{ span: 8 }}
                                                    wrapperCol={{ span: 14 }}
                                                    margin
                                                >
                                                    <SelectItem placeholder="Cirugia" disabled>
                                                        {this.state.objetoCirugias}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </>
                                ) : null}

                                // Contenido Moneda
                                monedaContent={(
                                    <>
                                        <FormItem
                                            required
                                            margin
                                            name="monedaId"
                                            labelCol={{ span: 8 }}
                                            wrapperCol={{ span: 24 }}
                                            initialValue='60c7e4396465ad440c41c15a'
                                        >
                                            <SelectItem disabled placeholder="Moneda">
                                                {this.state.objetoMonedas}
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                                            {({ getFieldValue }) => {
                                                const monedaId = getFieldValue('monedaId')
                                                if (monedaId === '60c7e4396465ad440c41c15a') {
                                                    return null;
                                                }
                                                return (
                                                    <FormItem
                                                        required
                                                        number
                                                        margin
                                                        label="T. Cambio"
                                                        name="tipoDeCambio"
                                                        type="number"
                                                        initialValue={1}
                                                        labelCol={{ span: 8 }}
                                                        wrapperCol={{ span: 16 }}
                                                    >
                                                        <InputNumberItem
                                                            disabled
                                                            dinero
                                                            placeholder="T. Cambio"
                                                        />
                                                    </FormItem>
                                                )
                                            }}
                                        </FormItem>
                                    </>
                                )}

                                showDoctor={this.props.equipoMedico}
                                showRegimenFiscal={false}
                                showMoneda={true}
                                gutter={[20, 16]}

                                // Tabs para Insumos y Entrega
                                tabs={[
                                    {
                                        key: "tabla",
                                        label: "Insumos",
                                        listName: "insumos",
                                        columns: this.getInsumosColumns(),
                                        renderRow: this.renderInsumoRow.bind(this),
                                        forceRender: true,
                                    },
                                    {
                                        key: "entrega",
                                        label: "Entrega",
                                        customContent: this.renderEntregaContent()
                                    }
                                ]}
                                defaultActiveKey="tabla"
                                onTabChange={(key) => {
                                    if (key === "entrega") {
                                        this.consultarInformacionEntrega()
                                    }
                                }}

                                // Observaciones y Totales
                                observacionesConfig={this.getObservacionesConfig()}

                                totalPagar={this.state.totalPagar}

                                // Botones de acción
                                actionButtons={
                                    <div style={{ display: "flex", justifyContent: "right" }}>
                                        <Space>
                                            {this.state.estado !== 0 && this.state.estado !== 3 && (
                                                <Popconfirm
                                                    title={'Seguro que quiere cancelar esta cotizacion?'}
                                                    onConfirm={() => this.cancelarCotizacion(this.state.id)}
                                                    okText="Ok"
                                                    cancelText="Cancelar"
                                                >
                                                    <ButtonItem
                                                        type="default"
                                                        hotkey="shift+c"
                                                        size="small"
                                                        rojoB
                                                    >
                                                        Cancelar
                                                    </ButtonItem>
                                                </Popconfirm>
                                            )}
                                            {this.state.estado === 1 && (
                                                <ButtonItem
                                                    type="primary"
                                                    hotkey="shift+v"
                                                    onClick={() => this.generarVentaDeCotizacion()}
                                                    disabled={this.state.tieneInsumoDeCambio}
                                                    cyanB
                                                >
                                                    Generar Venta
                                                </ButtonItem>
                                            )}
                                            {(this.state.estado === 1 && this.state.anticipos) && (
                                                <ButtonItem
                                                    type="primary"
                                                    hotkey="shift+a"
                                                    onClick={() => this.generarAnticipo()}
                                                    ambarB
                                                >
                                                    Generar Anticipo
                                                </ButtonItem>
                                            )}
                                            
                                            <ButtonItem
                                                type="primary"
                                                hotkey="shift+m"
                                                negroB
                                                icon={<SendOutlined />}
                                                onClick={() => this.enviarCotizacion(this.state.id)}
                                            >
                                                Mandar Correo
                                            </ButtonItem>
                                            <ButtonItem
                                                type="primary"
                                                verdeB
                                                icon={<FileExcelOutlined />}
                                                loading={this.state.descargandoExcel}
                                                onClick={this.descargarExcel.bind(this)}
                                            >
                                                Descargar Excel
                                            </ButtonItem>
                                            {this.props.preCotizacionIngenieria && (
                                                this.state.preCotizacionIngenieriaId ? (
                                                    <ButtonItem
                                                        type="primary"
                                                        cyanB
                                                        onClick={() => this.props.history.push("/panel/vistaPreCotizacionIngenieria", { id: this.state.preCotizacionIngenieriaId, modo: "ver" })}
                                                    >
                                                        Ver Pre Cotización
                                                    </ButtonItem>
                                                ) : (
                                                    <ButtonItem
                                                        type="primary"
                                                        cyanB
                                                        onClick={() => this.setState({ modalElegirPreCotizacionVisible: true })}
                                                    >
                                                        Ligar Pre Cotización
                                                    </ButtonItem>
                                                )
                                            )}
                                            <ButtonItem
                                                type="primary"
                                                 hotkey="shift+r"
                                                rojoB
                                                onClick={this.atras.bind(this)}
                                            >
                                                Regresar
                                            </ButtonItem>
                                        </Space>
                                    </div>
                                }
                            />
                        </Form>
                    </Spin>
                </div>
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
                </ModalItem>
                <MandarCorreoCotizacion
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoCotizacion={this.cerrarMandarCorreoCotizacion.bind(this)}
                />
                <ElegirPreCotizacion
                    visible={this.state.modalElegirPreCotizacionVisible}
                    cotizacionId={this.state.id}
                    history={this.props.history}
                    onCerrar={(seLigo) => {
                        this.setState({ modalElegirPreCotizacionVisible: false });
                        if (seLigo) this.consultarTodo();
                    }}
                />
                <GenerarVenta
                    visible={this.state.modalGenerarVenta}
                    id={this.state.id}
                    cerrarGenerarVentaDeContizacion={this.cerrarGenerarVentaDeContizacion.bind(this)}
                />
                <DetalleInsumoModal
                    visible={this.state.modalDetalleInsumoVisible}
                    onClose={this.cerrarDetalleInsumo}
                    insumoId={this.state.insumoSeleccionadoDetalle.id}
                    nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <DisponibilidadInsumoModal
                    visible={this.state.modalDisponibilidadVisible}
                    onClose={this.cerrarDisponibilidad}
                    insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
                    nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
                />
                <HistorialInsumoClienteModal
                    visible={this.state.modalHistorialClienteVisible}
                    onClose={this.cerrarHistorialCliente}
                    insumoId={this.state.insumoSeleccionadoHistorial.id}
                    nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
                    clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
                    excluirId={this.state.id}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.usuarioId,
        certificada: state.empresa.certificada,
        complementoDetallista: state.empresa.complementoDetallista,
        equipoMedico: state.empresa.equipoMedico,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
        preCotizacionIngenieria: state.empresa.preCotizacionIngenieria,
    };
};

export default connect(mapStateToProps)(VerCotizacion);